import { create } from "zustand";

interface AppState {
  collapsed: boolean;
}

interface AppActions {
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

export const useApp = create<AppState & AppActions>()((set) => ({
  collapsed: false,
  toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
  setCollapsed: (collapsed) => set({ collapsed }),
}));
